export default {
    getHeaderFields: state => state.headerFields,
    getDataTableOptions: state => state.dataTableOptions,
    getActions: state => state.actions,
}
